import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "modal fixed z-[75] left-0 top-0 flex items-center justify-center w-full h-full"
};
var _hoisted_2 = { class: "modal-body w-11/12 tablet:max-w-404 bg-white shadow-md relative z-[10]" };
var _hoisted_3 = { class: "pb-20 pt-4 px-8" };
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-close text-24px text-base-black" }, null, -1);
var _hoisted_5 = [
    _hoisted_4
];
var _hoisted_6 = { class: "mt-8" };
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-14px font-bold" }, "使用できないメールアドレスについて", -1);
var _hoisted_8 = { class: "list-circle" };
var _hoisted_9 = { class: "block" };
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-8 text-12px" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" 上記のようなアドレスは、世界標準から無効なメールアドレスとして認識され、登録いただくことができません。"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("大変恐れ入りますが、別のメールアドレスをご用意ください。 ")
    ])
], -1);
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotAvailableEmailModal',
    props: {
        open: { type: Boolean, required: true },
    },
    emits: [
        'onClose',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var notesArr = [
            ['@の直前に「.」(ドット)がある', '（例「aa.@xxxx.ne.jp」）'],
            ['メールアドレスの最初の文字が「.」(ドット)', '（例「.aa@xxxx.ne.jp」）'],
            ['「.」(ドット)が2つ以上連続する', '（例「a..a@xxxx.ne.jp」）'],
            ['「/」(スラッシュ)を含んでいる', '（例「aa/aa@xxxx.ne.jp」）'],
        ];
        var onClose = function () {
            emit('onClose');
        };
        return function (_ctx, _cache) {
            return (__props.open)
                ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", { class: "text-right leading-none" }, [
                                _createElementVNode("button", {
                                    class: "align-top",
                                    "btn-size": "24px",
                                    onClick: onClose
                                }, _hoisted_5)
                            ]),
                            _createElementVNode("section", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("ul", _hoisted_8, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(notesArr, function (item, i) {
                                        return _createElementVNode("li", {
                                            class: "mt-6",
                                            key: i
                                        }, [
                                            _createTextVNode(_toDisplayString(item[0]) + " ", 1),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(item[1]), 1)
                                        ]);
                                    }), 64))
                                ]),
                                _hoisted_10
                            ])
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "modal-bg z-[1] absolute left-0 top-0 w-full h-full bg-black bg-opacity-25",
                        onClick: onClose
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
